import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FloatButtonModel} from "./float-button.model";

@Component({
  selector: 'yz-float-button',
  styleUrls: [`./float-button.component.less`],
  templateUrl: `./float-button.component.html`,
})
export class YzFloatButtonComponent implements OnInit, OnDestroy {

  @Input() buttons: FloatButtonModel[] = [];

  constructor() {
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }
}
